<template>
  <section>

    <div class="uploads-button-wrapper">
      <input type="file"
             id="files-upload"
             ref="newFiles"
             @change="handleFilesUpload()"
             multiple />

      <button type="button"
              class="uploads-button btn-clean"
              @click="addFiles()"
              title="Dodaj plik">
        <h2 class="text-xl underline"
            v-accent="productData.single.msg.addFiles">
        </h2>
        <svg height="22" width="22"><use xlink:href="#iconAdd"></use></svg>
      </button>
    </div>

    <div v-if="uploadedFiles.length" class="scrollable-container">
      <ul class="downloads-list">
        <li v-for="(file, index) in uploadedFiles"
            :key="'download-item-' + index"
            class="downloads-item downloads-item-remove">
          <button type="button"
                  class="btn-clean"
                  :title="buttonData.removeFile"
                  @click="removeFile(index)">
            <svg height="22" width="22"><use xlink:href="#iconRemove"></use></svg>
          </button>
          <span class="downloads-item-title text-m">
            {{file.name}}
          </span>
          <small class="downloads-item-size text-xs"
                 v-if="file.weight">
            {{file.weight}}
          </small>
        </li>
      </ul>
    </div>

  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FilesUpload',
  data: function () {
    return {
      uploadedFiles: [],
      uploadedFilesArr: []
    }
  },
  methods: {
    addFiles () {
      this.$refs.newFiles.click()
    },
    removeFile (index) {
      this.uploadedFiles.splice(index, 1)
      this.uploadedFilesArr.splice(index, 1)
      this.$emit('uploadedFiles', this.uploadedFilesArr)
    },
    handleFilesUpload () {
      let newFiles = this.$refs.newFiles.files
      const isDuplicated = function (fileName) {
        return getName => getName.name === fileName
      }

      for (let i = 0; i < newFiles.length; i++) {
        let newFile = {
          name: newFiles[i].name,
          weight: this.formatBytes(newFiles[i].size)
        }
        if (!this.uploadedFiles.some(isDuplicated(newFiles[i].name))) {
          this.uploadedFiles.push(newFile)
          this.uploadedFilesArr.push(newFiles[i])
        }
      }
      this.$emit('uploadedFiles', this.uploadedFilesArr)
    },
    formatBytes (bytes, decimals) {
      const k = 1024
      const dm = decimals || 2
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let retSize = 0
      let i = Math.floor(Math.log(bytes) / Math.log(k))

      if (bytes > 0) {
        retSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
      }
      return retSize
    }
  },
  computed: {
    ...mapGetters([
      'buttonData',
      'productData'
    ])
  }
}
</script>

<style scoped lang="scss">

.section-files-upload {
  overflow: hidden;
  position: relative;
} // END .section-files-upload;

#files-upload {
  left: -99999em;
  position: absolute;
  top: 0;
} // END #files-upload;

.uploads-button {
  margin: 0 0 25px 0;
  padding: 0 ($downloads-list-icon-size + $gap-md) 0 0;
  text-align: left;
  width: 100%;
  z-index: 100;

  &:hover, &:focus {
    color: $text-accent;
  }

  h2 {
    margin-bottom: 0;
  }

  svg {
    fill: currentColor;
    height: $downloads-list-icon-size;
    margin-top: (($downloads-list-icon-size + $gap-md) / -2);
    position: absolute;
    right: 0;
    top: 50%;
    width: $downloads-list-icon-size;
  }

} // END .uploads-button

.scrollable-container {
  height: 100%;
  max-height: 290px;
}
</style>
